{
    "columns":[
		{
			"header_id": "tasBillingBatchMasterId",
			"header_label": "Batch master Id",
			"jsonpath":  "tasBillingBatchMasterId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "batchStatus",
			"header_label": "Batch Status",
			"jsonpath":  "batchStatus" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "recordCount",
			"header_label": "Record count",
			"jsonpath":  "recordCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "mcoCount",
			"header_label": "MCO count",
			"jsonpath":  "mcoCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "timesheetCount",
			"header_label": "Timesheet Count",
			"jsonpath":  "timesheetCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "ignoredTimesheets",
			"header_label": "Ignored Timesheets",
			"jsonpath":  "ignoredTimesheets" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "ignoredTimesheetCount",
			"header_label": "Ignored Timesheet Count",
			"jsonpath":  "ignoredTimesheetCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "pmPmFlg",
			"header_label": "PMPM",
			"jsonpath":  "pmPmFlg" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "batches.json",
	"pageName": "billing-batch-master-list",
	"orderByColumn": ["tasBillingBatchMasterId"],
	"orderBy": ["desc"]
}